import { gql } from "@apollo/client";

const REGISTER_MUTATION = gql`
  mutation register(
    $username: String!
    $password: String!
    $confirmedPassword: String!
    $email: String!
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
  ) {
    register(
      username: $username
      password: $password
      confirmedPassword: $confirmedPassword
      email: $email
      utm_source: $utm_source
      utm_medium: $utm_medium
      utm_campaign: $utm_campaign
    ) {
      success
      error
    }
  }
`;
export default REGISTER_MUTATION;
